import { FaShoppingCart } from "react-icons/fa";


const CartIcon = () => {
    return <FaShoppingCart size={24} />
};

export default CartIcon;